import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Temporary: while Beam payment links are down the backend sets BANK_TRANSFER_ONLY
// and every customer pays by bank transfer. Fetched once per page load and shared.
// On error we fall back to false; the backend still refuses to create links.
let modePromise = null;
const fetchMode = () => {
  if (!modePromise) {
    modePromise = axios
      .get(`${BACKEND_URL}/api/setting/payment-mode`)
      .then((res) => res.data?.bankTransferOnly === true)
      .catch(() => {
        modePromise = null;
        return false;
      });
  }
  return modePromise;
};

const useBankTransferOnly = () => {
  const [bankTransferOnly, setBankTransferOnly] = useState(false);

  useEffect(() => {
    let active = true;
    fetchMode().then((value) => {
      if (active) setBankTransferOnly(value);
    });
    return () => { active = false; };
  }, []);

  return bankTransferOnly;
};

export default useBankTransferOnly;
